// import React, { useEffect, useRef, useState } from "react";
// import Navbar from "../../components/Navbar";
// import Styles from "../../styles/exercise/createexercise.module.scss";
// import { useDispatch, useSelector } from "react-redux";
// import { Link, useNavigate } from "react-router-dom";
// import { adminRoutes } from "../../routers/AdminRouters";
// import {
//   addExercise,
//   exerciseVideoDelete,
//   exerciseVideoDeleteSecondary,
//   getCategory,
//   getOptions,
//   uploadVideos,
//   uploadVideoSecondary,
// } from "../../services";
// import cancelIcon from "../../assets/exersise/cancel-circle.png";
// import uploadIcon from "../../assets/exersise/upload.png";
// import deleteIcon from "../../assets/exersise/trash.png";
// import { ToastContainer } from "react-toastify";
// import {
//   changeExercisePrimaryVideoLoading,
//   changeExercisePrimaryVideoProgress,
//   changeExerciseSecondaryVideoLoading,
//   changeExerciseSecondaryVideoProgress,
//   toggle,
// } from "../../redux";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import PopupWithList from "./PopupWithList";
// function hhmmssToSeconds(time) {
//   const [hours, minutes, seconds] = time.split(":").map(Number);
//   return hours * 3600 + minutes * 60 + seconds;
// }

// function secondsToHhmmss(totalSeconds) {
//   const hours = Math.floor(totalSeconds / 3600);
//   const minutes = Math.floor((totalSeconds % 3600) / 60);
//   const seconds = totalSeconds % 60;
//   return [hours, minutes, seconds]
//     .map((unit) => String(unit).padStart(2, "0"))
//     .join(":");
// }

// const CreateExercise = () => {
//   const [fileThumbnailHD, setFileThumbnailHD] = useState(null);
//   const [fileThumbnail4K, setFileThumbnail4K] = useState(null);
//   const [selectedHdFile, setSelectedHdFile] = useState(null);
//   const [selectedFourKFile, setSelectedFourkFile] = useState(null);
//   const [uploadController, setUploadController] = useState(null);
//   const [uploadControllerSecondary, setUploadControllerSecondary] =
//     useState(null);
//   const navigate = useNavigate();
//   const progressBar = useSelector(
//     (state) => state.exercises.primaryVideoUploadProgress
//   );
//   const progressBarSecondary = useSelector(
//     (state) => state.exercises.secondaryVideoUploadProgress
//   );
//   const primaryVideoKey = useSelector(
//     (state) => state.exercises.primaryVideoKey
//   );
//   const secondaryVideoKey = useSelector(
//     (state) => state.exercises.secondaryVideoKey
//   );
//   const { categories } = useSelector((state) => state.exercises);

//   const { options } = useSelector((state) => state.exercises);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [selectedType, setSelectedType] = useState("");
//   const dispatch = useDispatch();
//   const isSidebarOpen = useSelector((state) => state.navbar.button);
//   const [time, setTime] = useState();
//   const nameRef = useRef();
//   const categoryRef = useRef();
//   const typeRef = useRef();
//   const setRef = useRef();
//   const repRef = useRef();
//   const tempRef = useRef();
//   const calRef = useRef();
//   const meterRef = useRef();
//   const hoursRef = useRef(null);
//   const minutesRef = useRef(null);
//   const secondsRef = useRef(null);
//   const blockTimingRef = useRef(null);
//   const wordPeriodsRef = useRef(null);
//   const restPeriodsRef = useRef(null);

//   useEffect(() => {
//     const fetchData = () => {
//       getCategory();
//       getOptions();
//     };
//     fetchData();
//   }, []);
//   const handleTimeChange = () => {
//     const hours = hoursRef.current.value.padStart(2, "0");
//     const minutes = minutesRef.current.value.padStart(2, "0");
//     const seconds = secondsRef.current.value.padStart(2, "0");

//     setTime(hhmmssToSeconds(`${hours}:${minutes}:${seconds}`));
//   };
//   const handleMainContainerClick = () => {
//     if (isSidebarOpen) {
//       dispatch(toggle());
//     }
//   };
//   const handleSubmit = async () => {
//     if (!nameRef.current.value.trim()) {
//       toast.error("Exercise Name is required.");
//       return false;
//     }
//     if (!categoryRef.current.value) {
//       toast.error("Please select a category.");
//       return false;
//     }
//     if (!selectedType) {
//       toast.error("Please select an exercise type.");
//       return false;
//     }
//     if (!primaryVideoKey && !secondaryVideoKey) {
//       toast.error("Please upload at least one video (HD or 4K).");
//       return false;
//     }
//     if (!setRef.current.value) {
//       toast.error("Please select the number of sets.");
//       return false;
//     }
//     if (!repRef.current.value) {
//       toast.error("Please select the number of reps.");
//       return false;
//     }
//     if (!tempRef.current.value) {
//       toast.error("Please select a tempo.");
//       return false;
//     }
//     if (!calRef.current.value) {
//       toast.error("Please select calories.");
//       return false;
//     }
//     if (!meterRef.current.value) {
//       toast.error("Please select meters.");
//       return false;
//     }
//     if (!time) {
//       toast.error("Please enter a valid time.");
//       return false;
//     }
//     if (!blockTimingRef.current.value) {
//       toast.error("Please select block timings.");
//       return false;
//     }
//     if (!wordPeriodsRef.current.value) {
//       toast.error("Please select work periods.");
//       return false;
//     }
//     if (!restPeriodsRef.current.value) {
//       toast.error("Please select rest periods.");
//       return false;
//     }
//     const formData = {
//       name: nameRef.current.value,
//       category: categoryRef.current.value,
//       type: selectedType,
//       videos: {
//         primary: primaryVideoKey || "",
//         secondary: secondaryVideoKey || "",
//       },
//       variables: {
//         sets: setRef.current.value,
//         reps: repRef.current.value,
//         tempos: tempRef.current?.value,
//         cals: calRef.current?.value,
//         meters: meterRef.current?.value,
//         time: time,
//       },
//       times: {
//         blockTimings: blockTimingRef.current?.value,
//         workPeriods: wordPeriodsRef.current?.value,
//         restPeriods: restPeriodsRef.current?.value,
//       },
//     };

//     const success = await addExercise(formData);

//     if (success) {
//       navigate(adminRoutes.listExercise);
//     } else {
//       console.error("Failed to add exercise.");
//     }
//   };

//   const handleCategoryChange = (event) => {
//     const categoryId = event.target.value;
//     const selected = categories.find((cat) => cat._id === categoryId);
//     setSelectedCategory(selected);
//     setSelectedType(""); // Reset type selection
//   };

//   const handleFileUpload = async (event) => {
//     const video = event.target.files[0];
//     if (video) {
//       setSelectedHdFile(video);
//       const fileURL = URL.createObjectURL(video);
//       setFileThumbnailHD(fileURL);
//       const controller = new AbortController();
//       setUploadController(controller);
//       const formData = new FormData();
//       formData.append("video", video);
//       await uploadVideos(video, controller.signal);
//     }
//   };
//   const handleCancel = () => {
//     if (uploadController) {
//       uploadController.abort();
//       console.log("Upload canceled by the user");
//       dispatch(changeExercisePrimaryVideoProgress(0));
//       dispatch(changeExercisePrimaryVideoLoading(false));
//     }
//   };
//   const triggerFileInput = () => {
//     document.getElementById("upload-hd-input").click();
//   };
//   const handleReuploadHd = () => {
//     if (selectedHdFile) {
//       uploadVideos(selectedHdFile);
//     } else {
//       console.error("No file selected for reupload");
//     }
//   };
//   const handleCancelSecondary = () => {
//     if (uploadControllerSecondary) {
//       uploadControllerSecondary.abort();
//       console.log("Upload canceled by the user");
//       dispatch(changeExerciseSecondaryVideoProgress(0));
//       dispatch(changeExerciseSecondaryVideoLoading(false));
//     }
//   };

//   const handleFileUploadSecondary = async (event) => {
//     const video = event.target.files[0];
//     if (video) {
//       setSelectedFourkFile(video);
//       const fileURL = URL.createObjectURL(video);
//       setFileThumbnail4K(fileURL);
//       const controller = new AbortController();
//       setUploadControllerSecondary(controller);
//       const formData = new FormData();
//       formData.append("video", video);
//       await uploadVideoSecondary(video, controller.signal);
//     }
//   };

//   const triggerFileInputSecondary = () => {
//     document.getElementById("upload-secondary-input").click();
//   };
//   const handleReuploadFourK = () => {
//     if (selectedFourKFile) {
//       uploadVideoSecondary(selectedFourKFile);
//     } else {
//       console.error("No file selected for reupload");
//     }
//   };
//   const handleDelete = async (key) => {
//     const resp = await exerciseVideoDelete(key);

//     setFileThumbnailHD(null);
//   };
//   const handleDelete4k = async (key) => {
//     const resp = await exerciseVideoDeleteSecondary(key);

//     setFileThumbnail4K(null);
//   };
//   const handleBack = () => {
//     navigate(adminRoutes.listExercise);
//   };

//   const [isPopupOpen, setIsPopupOpen] = useState(false);

//   const openPopup = () => setIsPopupOpen(true);
//   const closePopup = () => setIsPopupOpen(false);

//   const handleUpdateReps = () => {
//     closePopup();
//   };
//   return (
//     <>
//       <Navbar />
//       <ToastContainer />

//       <div
//         className={Styles.createexercise_main}
//         onClick={handleMainContainerClick}
//       >
//         <div className={Styles.createexercise_container}>
//           <h2>
//             <Link to={adminRoutes.dashboard} className={Styles.dark}>
//               HOME /
//             </Link>{" "}
//             <Link to={adminRoutes.listExercise} className={Styles.white}>
//               ALL EXERCISE /
//             </Link>{" "}
//             <span className={Styles.orange}>CREATE NEW EXERCISE</span>
//           </h2>
//         </div>
//         <div className={Styles.form_container}>
//           <div className={Styles.table_container_headingone}>
//             <h3>CREATE NEW EXERCISE</h3>
//           </div>

//           <div className={Styles.row_padding}>
//             <div className={Styles.row}>
//               <div className={Styles.input_group}>
//                 <label>Exercise Name</label>
//                 <input type="text" placeholder="Enter here" ref={nameRef} />
//               </div>
//               <div className={Styles.input_group}>
//                 <label>Category</label>
//                 <select onChange={handleCategoryChange} ref={categoryRef}>
//                   <option value="" disabled selected>
//                     Choose from list
//                   </option>{" "}
//                   {categories.map((category) => (
//                     <option key={category._id} value={category._id}>
//                       {category.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {selectedCategory &&
//                 Array.isArray(selectedCategory.subCategories) &&
//                 selectedCategory.subCategories.length > 0 && (
//                   <div className={Styles.input_radio}>
//                     <span>Types</span>
//                     {selectedCategory.subCategories.map(
//                       (subCategory, index) => (
//                         <label key={index}>
//                           <input
//                             type="radio"
//                             name="subCategories"
//                             value={subCategory}
//                             checked={selectedType === subCategory}
//                             onChange={(event) =>
//                               setSelectedType(event.target.value)
//                             }
//                           />
//                           {subCategory || "N/A"}
//                         </label>
//                       )
//                     )}
//                   </div>
//                 )}

//               <div className={Styles.input_group_upload}>
//                 {!fileThumbnailHD && (
//                   <div>
//                     {" "}
//                     <label>HD Video</label>
//                     <button
//                       style={{ marginTop: "1em" }}
//                       onClick={triggerFileInput}
//                     >
//                       <img src={uploadIcon} alt="Upload Icon" />
//                       Upload
//                     </button>
//                   </div>
//                 )}
//                 <input
//                   type="file"
//                   id="upload-hd-input"
//                   accept="video/*"
//                   style={{ display: "none" }}
//                   onChange={handleFileUpload}
//                 />

//                 {fileThumbnailHD && (
//                   <div className={Styles.thumbnail_container}>
//                     <video
//                       src={fileThumbnailHD}
//                       muted
//                       className={Styles.thumbnail}
//                     />
//                   </div>
//                 )}

//                 {progressBar !== 0 && (
//                   <div className={Styles.progress_container}>
//                     <div
//                       className={`${Styles.progress_bar} ${
//                         progressBar === -1
//                           ? Styles.error
//                           : progressBar === 100
//                           ? Styles.success
//                           : Styles.uploading
//                       }`}
//                       style={{
//                         width: `${
//                           progressBar === -1 ? "100%" : progressBar + "%"
//                         }`,
//                       }}
//                     ></div>
//                   </div>
//                 )}
//                 {progressBar === -1 && (
//                   <>
//                     <button
//                       onClick={handleReuploadHd}
//                       className={Styles.reupload_button}
//                     >
//                       <img src={uploadIcon} alt="Reupload Icon" />
//                       <span id={Styles.reupload}> Reupload</span>
//                     </button>
//                     <button
//                       onClick={() => handleDelete(primaryVideoKey)}
//                       className={Styles.delete_button}
//                       style={{ background: "transparent" }}
//                     >
//                       <img src={deleteIcon} alt="Delete Icon" />
//                     </button>
//                   </>
//                 )}

//                 {progressBar > 0 && progressBar < 100 && (
//                   <button
//                     className={Styles.cancel_button}
//                     onClick={handleCancel}
//                     style={{ background: "transparent" }}
//                   >
//                     <img src={cancelIcon} alt="Cancel Icon" />
//                   </button>
//                 )}
//                 {progressBar === 100 && (
//                   <button
//                     onClick={() => handleDelete(primaryVideoKey)}
//                     className={Styles.delete_button}
//                     style={{ background: "transparent" }}
//                   >
//                     <img src={deleteIcon} alt="Delete Icon" />
//                   </button>
//                 )}
//               </div>

//               <div className={Styles.input_group_upload}>
//                 {!fileThumbnail4K && (
//                   <div>
//                     {" "}
//                     <label>4K Video</label>
//                     <button
//                       style={{ marginTop: "1em" }}
//                       onClick={triggerFileInputSecondary}
//                     >
//                       <img src={uploadIcon} alt="Upload Icon" />
//                       Upload
//                     </button>
//                   </div>
//                 )}
//                 <input
//                   type="file"
//                   id="upload-secondary-input"
//                   accept="video/*"
//                   style={{ display: "none" }}
//                   onChange={handleFileUploadSecondary}
//                 />

//                 {fileThumbnail4K && (
//                   <div className={Styles.thumbnail_container}>
//                     <video
//                       src={fileThumbnail4K}
//                       muted
//                       className={Styles.thumbnail}
//                     />
//                   </div>
//                 )}

//                 {progressBarSecondary !== 0 && (
//                   <div className={Styles.progress_container}>
//                     <div
//                       className={`${Styles.progress_bar} ${
//                         progressBarSecondary === -1
//                           ? Styles.error
//                           : progressBarSecondary === 100
//                           ? Styles.success
//                           : Styles.uploading
//                       }`}
//                       style={{
//                         width: `${
//                           progressBarSecondary === -1
//                             ? "100%"
//                             : progressBarSecondary + "%"
//                         }`,
//                       }}
//                     ></div>
//                   </div>
//                 )}

//                 {progressBarSecondary === -1 && (
//                   <>
//                     <button
//                       onClick={handleReuploadFourK}
//                       className={Styles.reupload_button}
//                     >
//                       <img src={uploadIcon} alt="Reupload Icon" />
//                       <span id={Styles.reupload}> Reupload</span>
//                     </button>
//                     <button
//                       onClick={() => handleDelete4k(secondaryVideoKey)}
//                       className={Styles.delete_button}
//                       style={{ background: "transparent" }}
//                     >
//                       <img src={deleteIcon} alt="Delete Icon" />
//                     </button>
//                   </>
//                 )}
//                 {progressBarSecondary > 0 && progressBarSecondary < 100 && (
//                   <button
//                     className={Styles.cancel_button}
//                     onClick={handleCancelSecondary}
//                     style={{ background: "transparent" }}
//                   >
//                     <img src={cancelIcon} alt="Cancel Icon" />
//                   </button>
//                 )}
//                 {progressBarSecondary === 100 && (
//                   <button
//                     onClick={() => handleDelete4k(secondaryVideoKey)}
//                     className={Styles.delete_button}
//                     style={{ background: "transparent" }}
//                   >
//                     <img src={deleteIcon} alt="Delete Icon" />
//                   </button>
//                 )}
//               </div>
//             </div>
//             <div className={Styles.seperator}>
//               <span className={Styles.title}>VARIABLE</span> &nbsp;&nbsp;
//               <hr className={Styles.line} />
//             </div>
//             <div className={Styles.row}>
//               <div className={Styles.input_group}>
//                 <label>Sets</label>
//                 <select ref={setRef} className={Styles.dropdown_select}>
//                   <option value="" disabled selected>
//                     Choose from list
//                   </option>{" "}
//                   {options.sets.map((item, index) => (
//                     <option key={index} value={item}>
//                       {item}
//                     </option>
//                   ))}{" "}
//                 </select>
//               </div>

//               <div className={Styles.input_group}>
//                 <label>Reps</label>
//                 <select
//                   ref={repRef}
//                   onChange={(e) => {
//                     if (e.target.value === "update") {
//                       openPopup();
//                     }
//                   }}
//                   className={Styles.dropdown_select}>
//                   <option value="" disabled selected>
//                     Choose from list
//                   </option>{" "}
//                   {options.reps.map((item, index) => (
//                     <option key={index} value={item}>
//                       {item === -1 ? "Max" : item}
//                     </option>
//                   ))}
//                   {/* <option value="update">Update</option> */}
//                 </select>

//                 {isPopupOpen && (
//                   <PopupWithList
//                     options={options}
//                     onUpdate={handleUpdateReps}
//                     onClose={closePopup}
//                   />
//                 )}
//               </div>

//               <div className={Styles.input_group}>
//                 <label>Tempo</label>
//                 <select ref={tempRef} className={Styles.dropdown_select}>
//                   <option value="" disabled selected>
//                     Choose from list
//                   </option>{" "}
//                   {options.tempos.map((item, index) => (
//                     <option key={index} value={item}>
//                       {item}
//                     </option>
//                   ))}{" "}
//                 </select>
//               </div>
//             </div>
//             <br />
//             <div className={Styles.row}>
//               <div className={Styles.input_group}>
//                 <label>Cals</label>
//                 <select ref={calRef} className={Styles.dropdown_select}>
//                   <option value="" disabled selected>
//                     Choose from list
//                   </option>{" "}
//                   {options.cals.map((item, index) => (
//                     <option key={index} value={item}>
//                       {item}
//                     </option>
//                   ))}{" "}
//                 </select>
//               </div>
//               <div className={Styles.input_group}>
//                 <label>Meters</label>
//                 <select ref={meterRef} className={Styles.dropdown_select}>
//                   <option value="" disabled selected>
//                     Choose from list
//                   </option>{" "}
//                   {options.meters.map((item, index) => (
//                     <option key={index} value={item}>
//                       {item === -1 ? "Max" : item}
//                     </option>
//                   ))}{" "}
//                 </select>
//               </div>
//               <div className={Styles.input_group}>
//                 <label>Time</label>
//                 <div className={Styles.time_field}>
//                   <span className={Styles.icon}>
//                     <svg
//                       width="25"
//                       height="25"
//                       viewBox="0 0 25 24"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         d="M12.333 22C17.8559 22 22.333 17.5228 22.333 12C22.333 6.47715 17.8559 2 12.333 2C6.81016 2 2.33301 6.47715 2.33301 12C2.33301 17.5228 6.81016 22 12.333 22Z"
//                         stroke="#808080"
//                         stroke-width="1.5"
//                       />
//                       <path
//                         d="M12.333 8V12L14.333 14"
//                         stroke="#808080"
//                         stroke-width="1.5"
//                         stroke-linecap="round"
//                         stroke-linejoin="round"
//                       />
//                     </svg>
//                   </span>
//                   <input
//                     type="text"
//                     placeholder="00"
//                     minLength={1}
//                     min={1}
//                     max={2}
//                     maxLength={2}
//                     className={Styles.time_input}
//                     ref={hoursRef}
//                     onChange={handleTimeChange}
//                   />
//                   <span className={Styles.separator}>:</span>
//                   <input
//                     type="text"
//                     placeholder="00"
//                     minLength={1}
//                     maxLength={2}
//                     min={1}
//                     max={2}
//                     className={Styles.time_input}
//                     ref={minutesRef}
//                     onChange={handleTimeChange}
//                   />
//                   <span className={Styles.separator}>:</span>
//                   <input
//                     type="text"
//                     placeholder="00"
//                     minLength={1}
//                     maxLength={2}
//                     min={1}
//                     max={2}
//                     className={Styles.time_input}
//                     ref={secondsRef}
//                     onChange={handleTimeChange}
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className={Styles.seperator}>
//               <span className={Styles.title}>TIME</span> &nbsp;&nbsp;
//               <hr className={Styles.line} />
//             </div>{" "}
//             <div className={Styles.row}>
//               <div className={Styles.input_group}>
//                 <label>Block Timings</label>
//                 <select ref={blockTimingRef} className={Styles.dropdown_select}>
//                   <option value="" disabled selected>
//                     Choose from list
//                   </option>{" "}
//                   {options.blockTimings.map((item, index) => (
//                     <option key={index} value={item}>
//                       {item >= 60
//                         ? `${item / 60} minute(s)`
//                         : `${item} second(s)`}
//                     </option>
//                   ))}{" "}
//                 </select>
//               </div>
//               <div className={Styles.input_group}>
//                 <label>Work Periods</label>
//                 <select ref={wordPeriodsRef} className={Styles.dropdown_select}>
//                   <option value="" disabled selected>
//                     Choose from list
//                   </option>{" "}
//                   {options.workPeriods.map((item, index) => (
//                     <option key={index} value={item}>
//                       {item >= 60
//                         ? `${item / 60} minute(s)`
//                         : `${item} second(s)`}
//                     </option>
//                   ))}{" "}
//                 </select>
//               </div>
//               <div className={Styles.input_group}>
//                 <label>Rest Periods</label>
//                 <select ref={restPeriodsRef} className={Styles.dropdown_select}>
//                   <option value="" disabled selected>
//                     Choose from list
//                   </option>{" "}
//                   {options.blockTimings.map((item, index) => (
//                     <option key={index} value={item}>
//                       {item >= 60
//                         ? `${item / 60} minute(s)`
//                         : `${item} second(s)`}
//                     </option>
//                   ))}{" "}
//                 </select>
//               </div>
//             </div>
//           </div>

//           <div className={Styles.button_group_line} />
//           <div className={Styles.button_group}>
//             <button
//               className={Styles.save_button}
//               onClick={handleSubmit}
//               style={{ cursor: "pointer" }}
//             >
//               Save
//             </button>
//             <button
//               className={Styles.cancel_button}
//               onClick={handleBack}
//               style={{ cursor: "pointer" }}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default CreateExercise;

import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/exercise/createexercise.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import {
  addExercise,
  exerciseVideoDelete,
  exerciseVideoDeleteSecondary,
  getCategory,
  getOptions,
  uploadVideos,
  uploadVideoSecondary,
} from "../../services";
import cancelIcon from "../../assets/exersise/cancel-circle.png";
import uploadIcon from "../../assets/exersise/upload.png";
import deleteIcon from "../../assets/exersise/trash.png";
import { ToastContainer } from "react-toastify";
import {
  changeExercisePrimaryVideoLoading,
  changeExercisePrimaryVideoProgress,
  changeExerciseSecondaryVideoLoading,
  changeExerciseSecondaryVideoProgress,
  toggle,
} from "../../redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PopupWithList from "./PopupWithList";
function hhmmssToSeconds(time) {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

function secondsToHhmmss(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}

const CreateExercise = () => {
  const [fileThumbnailHD, setFileThumbnailHD] = useState(null);
  const [fileThumbnail4K, setFileThumbnail4K] = useState(null);
  const [selectedHdFile, setSelectedHdFile] = useState(null);
  const [selectedFourKFile, setSelectedFourkFile] = useState(null);
  const [uploadController, setUploadController] = useState(null);
  const [uploadControllerSecondary, setUploadControllerSecondary] =
    useState(null);
  const navigate = useNavigate();
  const progressBar = useSelector(
    (state) => state.exercises.primaryVideoUploadProgress,
  );
  const progressBarSecondary = useSelector(
    (state) => state.exercises.secondaryVideoUploadProgress,
  );
  const primaryVideoKey = useSelector(
    (state) => state.exercises.primaryVideoKey,
  );
  const secondaryVideoKey = useSelector(
    (state) => state.exercises.secondaryVideoKey,
  );
  const { categories } = useSelector((state) => state.exercises);

  const { options } = useSelector((state) => state.exercises);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const [time, setTime] = useState();
  const nameRef = useRef();
  const categoryRef = useRef();
  const typeRef = useRef();
  const setRef = useRef();
  const repRef = useRef();
  const tempRef = useRef();
  const calRef = useRef();
  const meterRef = useRef();
  const hoursRef = useRef(null);
  const minutesRef = useRef(null);
  const secondsRef = useRef(null);
  const blockTimingRef = useRef(null);
  const wordPeriodsRef = useRef(null);
  const restPeriodsRef = useRef(null);

  useEffect(() => {
    const fetchData = () => {
      getCategory();
      getOptions();
    };
    fetchData();
  }, []);
  const handleTimeChange = () => {
    const hours = hoursRef.current.value.padStart(2, "0");
    const minutes = minutesRef.current.value.padStart(2, "0");
    const seconds = secondsRef.current.value.padStart(2, "0");

    setTime(hhmmssToSeconds(`${hours}:${minutes}:${seconds}`));
  };
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  const resetForm = () => {
    // Reset input fields
    if (nameRef.current) nameRef.current.value = "";
    if (categoryRef.current) categoryRef.current.value = "";
    if (setRef.current) setRef.current.value = "";
    if (repRef.current) repRef.current.value = "";
    if (tempRef.current) tempRef.current.value = "";
    if (calRef.current) calRef.current.value = "";
    if (meterRef.current) meterRef.current.value = "";
    if (hoursRef.current) hoursRef.current.value = "";
    if (minutesRef.current) minutesRef.current.value = "";
    if (secondsRef.current) secondsRef.current.value = "";
    if (blockTimingRef.current) blockTimingRef.current.value = "";
    if (wordPeriodsRef.current) wordPeriodsRef.current.value = "";
    if (restPeriodsRef.current) restPeriodsRef.current.value = "";

    // Reset state variables
    setSelectedCategory("");
    setSelectedType("");
    setTime(undefined);
    setFileThumbnailHD(null);
    setFileThumbnail4K(null);
    setSelectedHdFile(null);
    setSelectedFourkFile(null);

    // Reset progress bars
    dispatch(changeExercisePrimaryVideoProgress(0));
    dispatch(changeExercisePrimaryVideoLoading(false));
    dispatch(changeExerciseSecondaryVideoProgress(0));
    dispatch(changeExerciseSecondaryVideoLoading(false));
  };

  // Modified handleSubmit function to conditionally check for type validation
  const handleSubmit = async () => {
    if (!nameRef.current.value.trim()) {
      toast.error("Exercise Name is required.");
      return false;
    }
    if (!categoryRef.current.value) {
      toast.error("Please select a category.");
      return false;
    }

    // Only validate type selection if the selected category has subcategories
    const categoryHasSubcategories =
      selectedCategory &&
      Array.isArray(selectedCategory.subCategories) &&
      selectedCategory.subCategories.length > 0;

    if (categoryHasSubcategories && !selectedType) {
      toast.error("Please select an exercise type.");
      return false;
    }

    if (!primaryVideoKey && !secondaryVideoKey) {
      toast.error("Please upload at least one video (HD or 4K).");
      return false;
    }
    // if (!setRef.current.value) {
    //   toast.error("Please select the number of sets.");
    //   return false;
    // }
    // if (!repRef.current.value) {
    //   toast.error("Please select the number of reps.");
    //   return false;
    // }
    // if (!tempRef.current.value) {
    //   toast.error("Please select a tempo.");
    //   return false;
    // }
    // if (!calRef.current.value) {
    //   toast.error("Please select calories.");
    //   return false;
    // }
    // if (!meterRef.current.value) {
    //   toast.error("Please select meters.");
    //   return false;
    // }
    // if (!time) {
    //   toast.error("Please enter a valid time.");
    //   return false;
    // }
    // if (!blockTimingRef.current.value) {
    //   toast.error("Please select block timings.");
    //   return false;
    // }
    // if (!wordPeriodsRef.current.value) {
    //   toast.error("Please select work periods.");
    //   return false;
    // }
    // if (!restPeriodsRef.current.value) {
    //   toast.error("Please select rest periods.");
    //   return false;
    // }
    const formData = {
      name: nameRef.current.value,
      category: categoryRef.current.value,
      type: categoryHasSubcategories ? selectedType : "", // Only include type if category has subcategories
      videos: {
        primary: primaryVideoKey || "",
        secondary: secondaryVideoKey || "",
      },
      variables: {
        // Default to "0" when the UI fields are hidden or not filled
        sets: setRef.current?.value || "0",
        reps: repRef.current?.value || "0",
        tempos: tempRef.current?.value || "0",
        cals: calRef.current?.value || "0",
        meters: meterRef.current?.value || "0",
        time: time || "0",
      },
      times: {
        blockTimings: blockTimingRef.current?.value || "0",
        workPeriods: wordPeriodsRef.current?.value || "0",
        restPeriods: restPeriodsRef.current?.value || "0",
      },
    };

    const success = await addExercise(formData);

    if (success) {
      resetForm();

      navigate(adminRoutes.listExercise);
    } else {
      console.error("Failed to add exercise.");
    }
  };

  const handleCategoryChange = (event) => {
    const categoryId = event.target.value;
    const selected = categories.find((cat) => cat._id === categoryId);
    setSelectedCategory(selected);
    setSelectedType(""); // Reset type selection
  };

  const handleFileUpload = async (event) => {
    const video = event.target.files[0];
    if (video) {
      setSelectedHdFile(video);
      const fileURL = URL.createObjectURL(video);
      setFileThumbnailHD(fileURL);
      const controller = new AbortController();
      setUploadController(controller);
      const formData = new FormData();
      formData.append("video", video);
      await uploadVideos(video, controller.signal);
    }
  };
  const handleCancel = () => {
    if (uploadController) {
      uploadController.abort();
      console.log("Upload canceled by the user");
      dispatch(changeExercisePrimaryVideoProgress(0));
      dispatch(changeExercisePrimaryVideoLoading(false));
    }
  };
  const triggerFileInput = () => {
    document.getElementById("upload-hd-input").click();
  };
  const handleReuploadHd = () => {
    if (selectedHdFile) {
      uploadVideos(selectedHdFile);
    } else {
      console.error("No file selected for reupload");
    }
  };
  const handleCancelSecondary = () => {
    if (uploadControllerSecondary) {
      uploadControllerSecondary.abort();
      console.log("Upload canceled by the user");
      dispatch(changeExerciseSecondaryVideoProgress(0));
      dispatch(changeExerciseSecondaryVideoLoading(false));
    }
  };

  const handleFileUploadSecondary = async (event) => {
    const video = event.target.files[0];
    if (video) {
      setSelectedFourkFile(video);
      const fileURL = URL.createObjectURL(video);
      setFileThumbnail4K(fileURL);
      const controller = new AbortController();
      setUploadControllerSecondary(controller);
      const formData = new FormData();
      formData.append("video", video);
      await uploadVideoSecondary(video, controller.signal);
    }
  };

  const triggerFileInputSecondary = () => {
    document.getElementById("upload-secondary-input").click();
  };
  const handleReuploadFourK = () => {
    if (selectedFourKFile) {
      uploadVideoSecondary(selectedFourKFile);
    } else {
      console.error("No file selected for reupload");
    }
  };
  const handleDelete = async (key) => {
    const resp = await exerciseVideoDelete(key);

    setFileThumbnailHD(null);
  };
  const handleDelete4k = async (key) => {
    const resp = await exerciseVideoDeleteSecondary(key);

    setFileThumbnail4K(null);
  };
  const handleBack = () => {
    navigate(adminRoutes.listExercise);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  const handleUpdateReps = () => {
    closePopup();
  };
  return (
    <>
      <Navbar />
      <ToastContainer />

      <div
        className={Styles.createexercise_main}
        onClick={handleMainContainerClick}
      >
        <div className={Styles.createexercise_container}>
          <h2>
            <Link to={adminRoutes.dashboard} className={Styles.dark}>
              HOME /
            </Link>{" "}
            <Link to={adminRoutes.listExercise} className={Styles.white}>
              ALL EXERCISE /
            </Link>{" "}
            <span className={Styles.orange}>CREATE NEW EXERCISE</span>
          </h2>
        </div>
        <div className={Styles.form_container}>
          <div className={Styles.table_container_headingone}>
            <h3>CREATE NEW EXERCISE</h3>
          </div>

          <div className={Styles.row_padding}>
            <div className={Styles.row}>
              <div className={Styles.input_group}>
                <label>Exercise Name</label>
                <input type="text" placeholder="Enter here" ref={nameRef} />
              </div>
              <div className={Styles.input_group}>
                <label>Category</label>
                <select onChange={handleCategoryChange} ref={categoryRef}>
                  <option value="" disabled selected>
                    Choose from list
                  </option>{" "}
                  {categories.map((category) => (
                    <option key={category._id} value={category._id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>

              {selectedCategory &&
                Array.isArray(selectedCategory.subCategories) &&
                selectedCategory.subCategories.length > 0 && (
                  <div className={Styles.input_radio}>
                    <span>Types</span>
                    {selectedCategory.subCategories.map(
                      (subCategory, index) => (
                        <label key={index}>
                          <input
                            type="radio"
                            name="subCategories"
                            value={subCategory}
                            checked={selectedType === subCategory}
                            onChange={(event) =>
                              setSelectedType(event.target.value)
                            }
                          />
                          {subCategory || "N/A"}
                        </label>
                      ),
                    )}
                  </div>
                )}

              <div className={Styles.input_group_upload}>
                {!fileThumbnailHD && (
                  <div>
                    {" "}
                    <label>HD Video</label>
                    <button
                      style={{ marginTop: "1em" }}
                      onClick={triggerFileInput}
                    >
                      <img src={uploadIcon} alt="Upload Icon" />
                      Upload
                    </button>
                  </div>
                )}
                <input
                  type="file"
                  id="upload-hd-input"
                  accept="video/*"
                  style={{ display: "none" }}
                  onChange={handleFileUpload}
                />

                {fileThumbnailHD && (
                  <div className={Styles.thumbnail_container}>
                    <video
                      src={fileThumbnailHD}
                      muted
                      className={Styles.thumbnail}
                    />
                  </div>
                )}

                {progressBar !== 0 && (
                  <div className={Styles.progress_container}>
                    <div
                      className={`${Styles.progress_bar} ${
                        progressBar === -1
                          ? Styles.error
                          : progressBar === 100
                            ? Styles.success
                            : Styles.uploading
                      }`}
                      style={{
                        width: `${
                          progressBar === -1 ? "100%" : progressBar + "%"
                        }`,
                      }}
                    ></div>
                  </div>
                )}
                {progressBar === -1 && (
                  <>
                    <button
                      onClick={handleReuploadHd}
                      className={Styles.reupload_button}
                    >
                      <img src={uploadIcon} alt="Reupload Icon" />
                      <span id={Styles.reupload}> Reupload</span>
                    </button>
                    <button
                      onClick={() => handleDelete(primaryVideoKey)}
                      className={Styles.delete_button}
                      style={{ background: "transparent" }}
                    >
                      <img src={deleteIcon} alt="Delete Icon" />
                    </button>
                  </>
                )}

                {progressBar > 0 && progressBar < 100 && (
                  <button
                    className={Styles.cancel_button}
                    onClick={handleCancel}
                    style={{ background: "transparent" }}
                  >
                    <img src={cancelIcon} alt="Cancel Icon" />
                  </button>
                )}
                {progressBar === 100 && (
                  <button
                    onClick={() => handleDelete(primaryVideoKey)}
                    className={Styles.delete_button}
                    style={{ background: "transparent" }}
                  >
                    <img src={deleteIcon} alt="Delete Icon" />
                  </button>
                )}
              </div>

              <div className={Styles.input_group_upload}>
                {!fileThumbnail4K && (
                  <div>
                    {" "}
                    <label>4K Video</label>
                    <button
                      style={{ marginTop: "1em" }}
                      onClick={triggerFileInputSecondary}
                    >
                      <img src={uploadIcon} alt="Upload Icon" />
                      Upload
                    </button>
                  </div>
                )}
                <input
                  type="file"
                  id="upload-secondary-input"
                  accept="video/*"
                  style={{ display: "none" }}
                  onChange={handleFileUploadSecondary}
                />

                {fileThumbnail4K && (
                  <div className={Styles.thumbnail_container}>
                    <video
                      src={fileThumbnail4K}
                      muted
                      className={Styles.thumbnail}
                    />
                  </div>
                )}

                {progressBarSecondary !== 0 && (
                  <div className={Styles.progress_container}>
                    <div
                      className={`${Styles.progress_bar} ${
                        progressBarSecondary === -1
                          ? Styles.error
                          : progressBarSecondary === 100
                            ? Styles.success
                            : Styles.uploading
                      }`}
                      style={{
                        width: `${
                          progressBarSecondary === -1
                            ? "100%"
                            : progressBarSecondary + "%"
                        }`,
                      }}
                    ></div>
                  </div>
                )}

                {progressBarSecondary === -1 && (
                  <>
                    <button
                      onClick={handleReuploadFourK}
                      className={Styles.reupload_button}
                    >
                      <img src={uploadIcon} alt="Reupload Icon" />
                      <span id={Styles.reupload}> Reupload</span>
                    </button>
                    <button
                      onClick={() => handleDelete4k(secondaryVideoKey)}
                      className={Styles.delete_button}
                      style={{ background: "transparent" }}
                    >
                      <img src={deleteIcon} alt="Delete Icon" />
                    </button>
                  </>
                )}
                {progressBarSecondary > 0 && progressBarSecondary < 100 && (
                  <button
                    className={Styles.cancel_button}
                    onClick={handleCancelSecondary}
                    style={{ background: "transparent" }}
                  >
                    <img src={cancelIcon} alt="Cancel Icon" />
                  </button>
                )}
                {progressBarSecondary === 100 && (
                  <button
                    onClick={() => handleDelete4k(secondaryVideoKey)}
                    className={Styles.delete_button}
                    style={{ background: "transparent" }}
                  >
                    <img src={deleteIcon} alt="Delete Icon" />
                  </button>
                )}
              </div>
            </div>
            {/* <div className={Styles.seperator}>
              <span className={Styles.title}>VARIABLE</span> &nbsp;&nbsp;
              <hr className={Styles.line} />
            </div>
            <div className={Styles.row}>
              <div className={Styles.input_group}>
                <label>Sets</label>
                <select ref={setRef} className={Styles.dropdown_select}>
                  <option value="" disabled selected>
                    Choose from list
                  </option>{" "}
                  {options.sets.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}{" "}
                </select>
              </div>

              <div className={Styles.input_group}>
                <label>Reps</label>
                <select
                  ref={repRef}
                  onChange={(e) => {
                    if (e.target.value === "update") {
                      openPopup();
                    }
                  }}
                  className={Styles.dropdown_select}>
                  <option value="" disabled selected>
                    Choose from list
                  </option>{" "}
                  {options.reps.map((item, index) => (
                    <option key={index} value={item}>
                      {item === -1 ? "Max" : item}
                    </option>
                  ))}
                </select>

                {isPopupOpen && (
                  <PopupWithList
                    options={options}
                    onUpdate={handleUpdateReps}
                    onClose={closePopup}
                  />
                )}
              </div>

              <div className={Styles.input_group}>
                <label>Tempo</label>
                <select ref={tempRef} className={Styles.dropdown_select}>
                  <option value="" disabled selected>
                    Choose from list
                  </option>{" "}
                  {options.tempos.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}{" "}
                </select>
              </div>
            </div>
            <br />
            <div className={Styles.row}>
              <div className={Styles.input_group}>
                <label>Cals</label>
                <select ref={calRef} className={Styles.dropdown_select}>
                  <option value="" disabled selected>
                    Choose from list
                  </option>{" "}
                  {options.cals.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}{" "}
                </select>
              </div>
              <div className={Styles.input_group}>
                <label>Meters</label>
                <select ref={meterRef} className={Styles.dropdown_select}>
                  <option value="" disabled selected>
                    Choose from list
                  </option>{" "}
                  {options.meters.map((item, index) => (
                    <option key={index} value={item}>
                      {item === -1 ? "Max" : item}
                    </option>
                  ))}{" "}
                </select>
              </div>
              <div className={Styles.input_group}>
                <label>Time</label>
                <div className={Styles.time_field}>
                  <span className={Styles.icon}>
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.333 22C17.8559 22 22.333 17.5228 22.333 12C22.333 6.47715 17.8559 2 12.333 2C6.81016 2 2.33301 6.47715 2.33301 12C2.33301 17.5228 6.81016 22 12.333 22Z"
                        stroke="#808080"
                        stroke-width="1.5"
                      />
                      <path
                        d="M12.333 8V12L14.333 14"
                        stroke="#808080"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <input
                    type="text"
                    placeholder="00"
                    minLength={1}
                    min={1}
                    max={2}
                    maxLength={2}
                    className={Styles.time_input}
                    ref={hoursRef}
                    onChange={handleTimeChange}
                    onKeyDown={(e) => {
                      if (e.key === '-') {
                        e.preventDefault();
                      }
                    }}
                  />
                  <span className={Styles.separator}>:</span>
                  <input
                    type="text"
                    placeholder="00"
                    minLength={1}
                    maxLength={2}
                    min={1}
                    max={2}
                    className={Styles.time_input}
                    ref={minutesRef}
                    onChange={handleTimeChange}
                    onKeyDown={(e) => {
                      if (e.key === '-') {
                        e.preventDefault();
                      }
                    }}
                  />
                  <span className={Styles.separator}>:</span>
                  <input
                    type="text"
                    placeholder="00"
                    minLength={1}
                    maxLength={2}
                    min={1}
                    max={2}
                    className={Styles.time_input}
                    ref={secondsRef}
                    onChange={handleTimeChange}
                    onKeyDown={(e) => {
                      if (e.key === '-') {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={Styles.seperator}>
              <span className={Styles.title}>TIME</span> &nbsp;&nbsp;
              <hr className={Styles.line} />
            </div>{" "}
            <div className={Styles.row}>
              <div className={Styles.input_group}>
                <label>Block Timings</label>
                <select ref={blockTimingRef} className={Styles.dropdown_select}>
                  <option value="" disabled selected>
                    Choose from list
                  </option>{" "}
                  {options.blockTimings.map((item, index) => (
                    <option key={index} value={item}>
                      {item >= 60
                        ? `${item / 60} minute(s)`
                        : `${item} second(s)`}
                    </option>
                  ))}{" "}
                </select>
              </div>
              <div className={Styles.input_group}>
                <label>Work Periods</label>
                <select ref={wordPeriodsRef} className={Styles.dropdown_select}>
                  <option value="" disabled selected>
                    Choose from list
                  </option>{" "}
                  {options.workPeriods.map((item, index) => (
                    <option key={index} value={item}>
                      {item >= 60
                        ? `${item / 60} minute(s)`
                        : `${item} second(s)`}
                    </option>
                  ))}{" "}
                </select>
              </div>
              <div className={Styles.input_group}>
                <label>Rest Periods</label>
                <select ref={restPeriodsRef} className={Styles.dropdown_select}>
                  <option value="" disabled selected>
                    Choose from list
                  </option>{" "}
                  {options.blockTimings.map((item, index) => (
                    <option key={index} value={item}>
                      {item >= 60
                        ? `${item / 60} minute(s)`
                        : `${item} second(s)`}
                    </option>
                  ))}{" "}
                </select>
              </div>
            </div> */}
          </div>

          <div className={Styles.button_group_line} />
          <div className={Styles.button_group}>
            <button
              className={Styles.save_button}
              onClick={handleSubmit}
              style={{ cursor: "pointer" }}
            >
              Save
            </button>
            <button
              className={Styles.cancel_button}
              onClick={handleBack}
              style={{ cursor: "pointer" }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateExercise;
